<template>
  <h2 class="skewt-title">{{ airport.icao_id }}   HRRR   {{ responseJson.model_run_time }}</h2>
  <h4 class="skewt-subtitle">Lat: {{ responseJson.lat }}°  /  Lon: {{ responseJson.lon }}°</h4>
  <div id="skewt-container" class="skewt-container" style="width: 100%; height:80%; background-color: white; max-width: 800px; margin: 0 auto;">
    <skew-t-component id="skewt" ref="skewT"></skew-t-component>
  </div>
</template>
<script>
import { getServiceHostPreference } from '@/services/utils/getServiceHostPreference';
// import AppConst from '@/constants/app.constant';
import utilityService from '@/services/utility.service';
import '../skew-t/skew-t-component';
import { onMounted, ref } from 'vue';
import * as d3 from 'd3';

export default {
  props: {
    settings: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    window.d3 = d3;
    const skewT = ref(null);
    const airport = ref({});
    const responseJson = ref({});

    const renderSkewT = async () => {
      try {
        let matchedAirport = utilityService.getMatchedAirportObject(props.settings.start);
        if (!matchedAirport) {
          alert('No matching airport found for the provided settings.');
          return;
        }
        airport.value = matchedAirport;
        if (!(matchedAirport.lat) || !(matchedAirport.lng)) {
          alert('Invalid latitude or longitude for the selected airport.');
          return;
        }
        const response = await fetch(getServiceHostPreference() + `/api/skew-t/skewt-hrrr/${matchedAirport.lat}/${matchedAirport.lng}`);
        if (!response.ok) {
          const errorData = await response.json();
          alert('Error: ' + (errorData.detail || 'Something went wrong.'));
          return;
        }
        responseJson.value = await response.json();
        if (responseJson.value && Array.isArray(responseJson.value.json_data) && responseJson.value.json_data.length > 0) {
          const linesData = responseJson.value.json_data[0].lines;
          skewT.value.skewt.plot(linesData);
        } else {
          alert('No sounding data found for the selected station.');
        }
      } catch (err) {
        console.error('Fetch error:', err);
        alert('Error fetching data: ' + (err?.message || 'Unexpected error'));
      }
    };

    onMounted(async () => {
      renderSkewT();
    });

    return { skewT, renderSkewT, airport, responseJson };
  },

  watch: {
    settings: {
      handler(newSettings) {
        if (newSettings.start) {
          this.renderSkewT();
        }
      },
      deep: true,
    },
  },
};
</script>
<style scoped>
.skewt-title {
  font-size: 1.5rem;
  text-align: center;
  font-weight: bold;
}
.skewt-subtitle {
  font-size: 1rem;
  text-align: center;
  margin-bottom: 1rem;
  font-weight: bold;
}
.skewt-container {
  padding-top: 0;
}
</style>